const E = {
  SHOW_PERMIT_REQUIREMENTS: "SHOW_PERMIT_REQUIREMENTS",
  SHOW_APPLICATION_REQUIREMENTS: "SHOW_APPLICATION_REQUIREMENTS",
  SHOW_LOT_AND_PROPOSAL: "SHOW_LOT_AND_PROPOSAL",
  SHOW_NEXT_STEPS: "SHOW_NEXT_STEPS",
  RESTART_CONVERSATION: "RESTART_CONVERSATION",
  EDIT_PROPOSAL: "EDIT_PROPOSAL"
}, S = {
  "": "",
  off_topic: "off_topic",
  new_conv: "new_conv",
  proposal_details: "proposal_details",
  lot_details: "lot_details",
  in_progress: "in_progress",
  ready_for_assessment: "ready_for_assessment",
  report_ready: "report_ready",
  amendment: "amendment",
  saved_report: "saved_report",
  sent_to_council: "sent_to_council",
  conv_routing: "conv_routing"
}, _ = {
  NoPermitRequired: "1",
  MoreInformationRequired: "2",
  RequiresPermit: "3",
  Prohibited: "4"
}, T = {
  ASSISTANT: "ASSISTANT",
  PLANNER: "PLANNER",
  SYSTEM: "SYSTEM",
  USER: "USER"
}, N = {
  USER: "USER",
  ASSISTANT: "ASSISTANT",
  PLANNER: "PLANNER"
}, R = {
  AMENDMENT: "AMENDMENT",
  CHOICES_QUESTION: "CHOICES_QUESTION",
  DISCLAIMER_ACCEPTANCE: "DISCLAIMER_ACCEPTANCE",
  FINALISE_DETAILS: "FINALISE_DETAILS",
  YES_NO_LIST_QUESTION: "YES_NO_LIST_QUESTION",
  FOLLOW_UP: "FOLLOW_UP",
  OFF_TOPIC: "OFF_TOPIC",
  OVERWRITE: "OVERWRITE",
  PLANNER_MESSAGE: "PLANNER_MESSAGE",
  REVIEW_PROPOSAL: "REVIEW_PROPOSAL",
  ROUTING_QUESTION: "ROUTING_QUESTION",
  SITE_OVERVIEW: "SITE_OVERVIEW",
  STANDARD: "STANDARD",
  SYSTEM_ERROR: "SYSTEM_ERROR",
  TREE_DIAMETER_QUESTION: "TREE_DIAMETER_QUESTION",
  TREE_DISTANCE_QUESTION: "TREE_DISTANCE_QUESTION",
  TREE_MODULE_QUESTION: "TREE_MODULE_QUESTION",
  NEARBY_TREES_QUESTION: "NEARBY_TREES_QUESTION",
  REMOVING_OR_PRUNING_QUESTION: "REMOVING_OR_PRUNING_QUESTION"
}, I = {
  ADMIN: "ADMIN",
  ASSISTANT: "ASSISTANT",
  COUNCIL_USER: "COUNCIL_USER",
  END_USER: "END_USER",
  SYSTEM: "SYSTEM"
};
export {
  T as A,
  S as C,
  I as G,
  R as M,
  E as a,
  _ as b,
  N as c
};
//# sourceMappingURL=conversations-B6_5aJ5K.js.map
